module.exports = __webpack_public_path__ + "static/media/30.84361a98.png";